import script from "./LandingResourceEarningsCalculator.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingResourceEarningsCalculator.vue?vue&type=script&setup=true&lang=js"

import "./LandingResourceEarningsCalculator.vue?vue&type=style&index=0&id=7bdc80cc&scoped=true&lang=css"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bdc80cc"]])

export default __exports__